// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___528f2a8946f81d9e06b","cls2":"ImpactHubModal-cls2___f1acc2ede3fcb61e658 ImpactHubModal-cls1___528f2a8946f81d9e06b"};